<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>

<ng-template #loadedContent>
	<div class="attachments-container">
		<div class="file-upload">
			<h5 class="text-primary">Upload New Attachments</h5>
			<app-file-upload [formGroup]="form" name="attachments" [multiple]="true" [allowedTypes]="allowedTypes" [disabled]="disabled">
			</app-file-upload>

			<ng-container *ngIf="form.controls.attachments.value && form.controls.attachments.value.length > 0">
				<app-alert
					[alertType]="AlertTypes.WARNING"
					content="You have uploaded files that haven't been saved yet. Make sure to click Save to keep your changes."
					[dismissible]="true"
				></app-alert>
			</ng-container>
		</div>

		<div class="existing-files">
			<h5 class="text-primary">Existing Attachments</h5>
			<div class="attachments-wrapper">
				<ng-container *ngIf="attachments.length > 0; else noAttachments">
					<ng-container *ngFor="let attachment of attachments; let i = index">
						<app-job-card-attachment
							[attachment]="attachment"
							[readonly]="false"
							(removeAttachment)="removeAttachment($event)"
							(editAttachmentDescription)="editAttachmentDescription($event)"
						></app-job-card-attachment>
					</ng-container>
				</ng-container>
				<ng-template #noAttachments>
					<em>No Existing Attachments</em>
				</ng-template>
			</div>
		</div>
	</div>
</ng-template>
